export const API_CONTRACT_HIRE = 'contract-hire';
export const API_CONTRACT_EXTENSION = 'contract-extension';
export const API_CONTRACT_NOT_EXTENSION = 'contract-extension-not-sign';
export const API_EXIT = 'exit';
